import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import DielLogoNegative from '../../assets/img/logos/DielLogoNegative.svg';
import { PoweredByLogo, PoweredByText } from './styles';

export type PoweredByDielSize = 'menu' | 'login';

interface PoweredByDielProps {
  /** Nome acessível da logo Diel. */
  logoAlt?: string;
  showText?: boolean;
  /** `menu`: rodapé dos menus lateral e mobile; `login`: rodapé das telas de login. */
  size?: PoweredByDielSize;
}

/** "Powered by" + logo Diel negativa, para fundos escuros. */
export const PoweredByDiel = ({ logoAlt = 'diel logo', showText = true, size = 'menu' }: Readonly<PoweredByDielProps>): ReactElement => {
  const { t } = useTranslation();

  return (
    <>
      {showText ? (
        <>
          <PoweredByText>{t('poweredBy')}</PoweredByText>
          {' '}
        </>
      ) : null}
      <PoweredByLogo src={DielLogoNegative} alt={logoAlt} $size={size} />
    </>
  );
};
